"use server";

import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/server";

import {
  passkeyLogin,
  passkeyLoginOptions,
  runLoginStep,
  type LoginState,
} from "@/lib/auth/login-steps";

// The steps of the one sign-in page, for clients and staff alike. The logic
// lives in lib/auth/login-steps.ts; the providers in auth.ts work out which
// kind of account an email or passkey belongs to.

export type { LoginState, LoginStep } from "@/lib/auth/login-steps";

export async function loginAction(_prev: LoginState, formData: FormData): Promise<LoginState> {
  return runLoginStep(formData);
}

export async function passkeyOptionsAction(): Promise<PublicKeyCredentialRequestOptionsJSON | null> {
  return passkeyLoginOptions();
}

export async function passkeyLoginAction(
  responseJSON: string,
  callbackUrl: string,
): Promise<{ error: string }> {
  return passkeyLogin(responseJSON, callbackUrl);
}
